import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import DeleteAll from './components/DeleteAll';
import PrepaidCardList from './components/PrepaidCardList';
import styles from './styles.module.scss';

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardManageActivity: {};
    }
}

const PrepaidCardManageActivity: ActivityComponentType<'PrepaidCardManageActivity'> = () => {
    const { t } = useTranslation('prepaidCard');
    return (
        <AppScreen>
            <Column fullWidth className={styles.root}>
                <Header title={t('manage.title')} />
                <DeleteAll/>
                <PrepaidCardList/>
            </Column>
        </AppScreen>
    );
};

export default PrepaidCardManageActivity;
